import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/Image_placeholder.svg")